// extracted by mini-css-extract-plugin
export var centerText = "_dh-8";
export var container = "_dh-0";
export var doughnutContainer = "_dh-7";
export var legend = "_dh-a";
export var legendItemColorDisplay = "_dh-b";
export var legendItemLabel = "_dh-d";
export var legendItemValue = "_dh-c";
export var lg = "_dh-5";
export var maxWidth = "_dh-9";
export var md = "_dh-4";
export var responsive = "_dh-6";
export var sm = "_dh-3";
export var xs = "_dh-2";
export var xxs = "_dh-1";